const LICENSE_STATUS_KEY = "tyretrack_license_status";

export const computeLicenseState = ({
  expireLicenses = null,
  maxTyreNo = null,
  totalInStock = 0,
} = {}) => {
  const expirationDate = expireLicenses ? new Date(expireLicenses) : null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const isExpired = !expirationDate || Number.isNaN(expirationDate.getTime()) || expirationDate < today;
  const normalizedMaxTyreNo = maxTyreNo != null && Number.isFinite(Number(maxTyreNo)) ? Number(maxTyreNo) : null;

  return {
    expireLicenses,
    maxTyreNo: normalizedMaxTyreNo,
    totalInStock: Number(totalInStock) || 0,
    isExpired,
    isOverLimit: !isExpired && normalizedMaxTyreNo !== null && normalizedMaxTyreNo < (Number(totalInStock) || 0),
  };
};

export const getLicenseStatus = (userId) => {
  const rawStatus = localStorage.getItem(LICENSE_STATUS_KEY);
  if (!rawStatus) {
    return null;
  }

  try {
    const status = JSON.parse(rawStatus);
    return status?.userId === userId ? status : null;
  } catch {
    localStorage.removeItem(LICENSE_STATUS_KEY);
    return null;
  }
};

export const saveLicenseStatus = (userId, licenseStatus) => {
  localStorage.setItem(
    LICENSE_STATUS_KEY,
    JSON.stringify({ ...licenseStatus, userId, checkedAt: new Date().toISOString() }),
  );
};

export const clearLicenseStatus = () => {
  localStorage.removeItem(LICENSE_STATUS_KEY);
};
